import { createAction } from '@reduxjs/toolkit'

import type { ConfirmationData } from './types'

export const InternalConfirmActions = {
  set: createAction<ConfirmationData>('CONFIRMATION_SET'),
  clear: createAction('CONFIRMATION_CLEAR'),
  submit: createAction('CONFIRMATION_SUBMIT'),
  close: createAction('CONFIRMATION_CONFIRMATION_CLOSE'),
}

export const OpenConfirmation = createAction<ConfirmationData>(
  'CONFIRMATION_CONFIRMATION_OPEN'
)
